// @ts-check

import { memo, useState } from 'react'
import { Route, useRouteMatch } from 'react-router'

/**
 * @typedef {Pick<import('react-router').RouteProps, 'exact' | 'path'> & {
 *  returnToParent?: boolean
 *  children: React.ComponentType<MuiModalRouteRendererProps>
 * }} MuiModalRouteProps
 */

/**
 * @typedef {{
 *  closeModal: () => void
 *  modalOpen: boolean
 * }} MuiModalRouteRendererProps
 */

/** @type {React.FC<MuiModalRouteProps>} */
const MuiModalRoute = (props) => {
  const [modalOpen, setModalOpen] = useState(false)
  const urlOutsideRoute = useRouteMatch().url

  return (
    <Route
      exact={props.exact}
      path={props.path}
      render={({ history }) => {
        // TODO This definitely seems like it can inadvertently re-open the
        // modal.
        // In practice, that's not happening.
        setModalOpen(true)

        // Using it as ComponentType / JSX lets you use hooks in the "render
        // prop".
        const Component = props.children
        return (
          <Component
            closeModal={() => {
              if (props.returnToParent) {
                history.push(urlOutsideRoute)
              } else {
                history.goBack()
              }
            }}
            modalOpen={modalOpen}
          />
        )
      }}
    />
  )
}

export default memo(MuiModalRoute)
